export default {"src":"/_next/static/media/FilterIcon.20ffabaf.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};